import styled from 'styled-components';
import {
  StyledImageHolder,
  StyledImageOverlay
} from '../../../../../../../PlusWebsiteEditor/components/ImageUploader/ImageUploader.styles';
import BlobImageUploader from './components/BlobImageUploader';

export const StyledImageUploader = styled(BlobImageUploader)`
  width: 320px;
  position: relative;

  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    z-index: -1;
    width: 100%;
    height: 125px;
  }

  ${StyledImageOverlay} {
    height: 180px;
  }

  ${StyledImageHolder} {
    height: 180px;
  }
`;
